<template>
  <main
    class="main customer_index bg_gr"
    role="main"
    ref="main"
    v-show="isCompleted"
    id="home_index"
  >
    <div class="home">
      <section class="h_sec main_service">
        <div class="txt_area">
          <h3>
            <span>{{ user.nickname }}</span
            >님,<br />무엇을 고민 중이세요?
          </h3>
          <h1>상품을 찾고<br />견적을 받아보세요!</h1>
        </div>
        <div class="btn_area">
          <button @click="goLink('InternetCommerce.Main')">
            <img
              src="@/assets/front/images/v2/service/ic_mainservice_internet.svg"
            />
            <span>인터넷/TV</span>
          </button>
          <button @click="goLink('Mobile.Main')">
            <img
              src="@/assets/front/images/v2/service/ic_mainservice_phone.svg"
            />
            <span>휴대폰</span>
          </button>
        </div>
        <div class="btn_guide">
          <button @click="goLink('Manual.Main')">ⓘ 상품 탐색 가이드</button>
        </div>
      </section>

      <section class="h_sec main_promotion" v-if="false">
        <div class="h_sec_ttl_2"><h4>퍼스 X 우수매장 프로모션!</h4></div>
        <div class="h_sec_ttl_sub">
          퍼스가 검증한 우수매장에서 상담부터 가입까지 빠르게!
        </div>
        <div class="sec_cont">
          <div class="p_reco_tab">
            <button
              class="on"
              @click="p_reco_tab_sel('p_internet_tv_tab', 'p_internet_tv_cont')"
              id="p_internet_tv_tab"
            >
              인터넷+TV
            </button>
            <button
              @click="p_reco_tab_sel('p_internet_tab', 'p_internet_cont')"
              id="p_internet_tab"
            >
              인터넷
            </button>
          </div>
          <div class="p_reco_cont on" id="p_internet_tv_cont">
            <!--인터넷/티비-->
            <ul>
              <li
                v-for="(item, index) in internetTvPromotion"
                :key="index"
                @click="goProductView(item.id)"
              >
                <div class="cont_top">
                  <img
                    :src="
                      require(`@/assets/front/images/v2/logos/${getLogoImg(
                        item.telecomId,
                      )}.svg`)
                    "
                    class="logo"
                  />
                  <div class="top_txt">가입(변경)</div>
                </div>
                <p>
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/i_main_s_my_internet.svg`)
                    "
                    class="img"
                  />
                  {{ item.internetName }}
                </p>
                <p>
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/i_main_s_my_tv.svg`)
                    "
                    class="img"
                  />
                  {{ item.tvName }}
                </p>
                <div class="supp_cont">
                  <div class="supp_title">확정지원금</div>
                  <div class="supp_price">
                    {{
                      getNumberToKorean(
                        item.cashSupport +
                          item.giftCardSupport +
                          item.perceSupport,
                      )
                    }}<span>만원</span>
                  </div>
                </div>
                <div class="supp_txt">
                  매장지원
                  {{
                    getNumberToKorean(item.cashSupport + item.giftCardSupport)
                  }}만원 + 퍼스지원
                  {{ getNumberToKorean(item.perceSupport) }}만원
                </div>
              </li>
            </ul>
          </div>
          <div class="p_reco_cont" id="p_internet_cont">
            <!--인터넷-->
            <ul>
              <li
                v-for="(item, index) in internetPromotion"
                :key="index"
                @click="goProductView(item.id)"
              >
                <div class="cont_top">
                  <img
                    :src="
                      require(`@/assets/front/images/v2/logos/${getLogoImg(
                        item.telecomId,
                      )}.svg`)
                    "
                    class="logo"
                  />
                  <div class="top_txt">가입(변경)</div>
                </div>
                <p>
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/i_main_s_my_internet.svg`)
                    "
                    class="img"
                  />
                  {{ item.internetName }}
                </p>
                <div class="supp_cont">
                  <div class="supp_title">확정지원금</div>
                  <div class="supp_price">
                    {{
                      getNumberToKorean(
                        item.cashSupport +
                          item.giftCardSupport +
                          item.perceSupport,
                      )
                    }}<span>만원</span>
                  </div>
                </div>
                <div class="supp_txt">
                  매장지원
                  {{
                    getNumberToKorean(item.cashSupport + item.giftCardSupport)
                  }}만원 + 퍼스지원
                  {{ getNumberToKorean(item.perceSupport) }}만원
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="h_sec main_deal" v-if="dealBnr">
        <div class="h_sec_ttl" @click="goMobileDeal('MAIN_CENTER_TITLE')">
          <h4>퍼스 단독 특가 상품</h4>
          <button>></button>
        </div>
        <div class="deal_img" @click="goMobileDeal('MAIN_CENTER')">
          <img :src="dealBnr" alt="" />
        </div>
      </section>
      <section
        class="h_sec main_promotion_kt"
        v-if="ktPromotionView || helloPromotionView"
      >
        <div class="h_sec_ttl"><h4>퍼스에서 진행중인 프로모션</h4></div>

        <Swiper
          :options="swiperOptionPromotionBnr"
          ref="swiperOptionPromotionBnr"
          @click-slide="clickSlide"
        >
          <SwiperSlide v-for="(item, index) in centerBnr" :key="index">
            <div class="promo_kt_img">
              <img
                :src="require(`@/assets/front/images/banner/main/${item.img}`)"
                alt=""
              />
            </div>
          </SwiperSlide>
          <!-- <div class="swiper-pagination-popup" slot="pagination"></div> -->
        </Swiper>
      </section>
      <section class="h_sec main_recommend">
        <div class="h_sec_ttl"><h4>내 또래 BEST 상품</h4></div>
        <div class="sec_cont">
          <div class="reco_tab">
            <button
              class="on"
              @click="reco_tab_sel('internet_tv_tab', 'internet_tv_cont')"
              id="internet_tv_tab"
            >
              인터넷+TV
            </button>
            <button
              @click="reco_tab_sel('internet_tab', 'internet_cont')"
              id="internet_tab"
            >
              인터넷
            </button>
            <button
              @click="reco_tab_sel('mobile_tab', 'mobile_cont')"
              id="mobile_tab"
            >
              휴대폰
            </button>
          </div>
          <div class="reco_cont on" id="internet_tv_cont">
            <!--인터넷/티비-->
            <ul>
              <li
                v-for="(item, index) in products.internetntvs"
                :key="index"
                @click="goProductList(item.telecomId, 'INTERNETNTV')"
              >
                <img
                  :src="
                    require(`@/assets/front/images/v2/logos/${getLogoImg(
                      item.telecomId,
                    )}.svg`)
                  "
                  class="logo"
                />
                <p>{{ decodeBase64(item.productName) }}</p>
              </li>
            </ul>
          </div>
          <div class="reco_cont" id="internet_cont">
            <!--인터넷-->
            <ul>
              <li
                v-for="(item, index) in products.internets"
                :key="index"
                @click="goProductList(item.telecomId, 'INTERNET')"
              >
                <img
                  :src="
                    require(`@/assets/front/images/v2/logos/${getLogoImg(
                      item.telecomId,
                    )}.svg`)
                  "
                  class="logo"
                />
                <p>{{ decodeBase64(item.productName) }}</p>
              </li>
            </ul>
          </div>
          <div class="reco_cont" id="mobile_cont">
            <!--휴대폰-->
            <ul>
              <li
                v-for="(item, index) in products.mobiles"
                :key="index"
                @click="goMobileView(item)"
              >
                <img :src="`${item.modelImage}`" class="phone" />
                <p>{{ item.modelName }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="h_sec main_review">
        <div class="h_sec_ttl"><h4>생생한 리뷰</h4></div>
        <div class="sec_cont">
          <ul class="sec_cont_list">
            <li
              v-for="(item, index) in reviews"
              :key="index"
              @click="moreReview(item.storeId)"
            >
              <div class="top">
                <div class="profile_image">
                  <div class="thumb_image">
                    <div class="thumb_image_inner">
                      <img
                        v-if="item.photoThumb"
                        :src="item.photoThumb"
                        alt=""
                      />
                      <img
                        v-else
                        :src="
                          require(`@/assets/front/images/v2/profiles/img_profile_${getProfileNum(
                            item.userId,
                          )}.png`)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="txt">
                  <div class="name">
                    <h5>{{ item.nickName }}</h5>
                    <div
                      class="star_wrap"
                      v-for="(rate, index) in item.rating"
                      :key="index"
                    >
                      <div :class="{ on: item.rating >= rate }"></div>
                    </div>
                  </div>
                  <p class="date">{{ getCreateAt(item.createdAt) }}</p>
                </div>
              </div>
              <div class="mid">
                <p>
                  {{ item.comment }}
                </p>
              </div>
              <div class="btm">
                <p v-if="item.isBuyer === 'Y'" class="buyer">
                  <i class="i_buy_check"></i>실구매고객
                </p>
                <p v-if="item.reviewInternet === 1">#인터넷상담</p>
                <p v-if="item.reviewMobile === 1">#휴대폰상담</p>
              </div>
              <!--이후적용 아니면 기존 구매고객, 인터넷상담 그거 넣어도 좋을거같음-->
            </li>
          </ul>
        </div>
      </section>
      <section class="h_sec main_permmunity">
        <div class="h_sec_ttl" @click="goLink('Knowhow.List')">
          <h4>퍼뮤니티</h4>
          <button>></button>
        </div>
        <div class="sec_cont">
          <ul>
            <li
              v-for="(item, index) in knowhowList"
              :key="index"
              @click="goKnowhowDetail(item.id)"
            >
              <p>
                {{ item.title }}
              </p>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <AppPushModal :show="isShowAppPushModal" />
    <ReviewReminder
      ref="reviewReminder"
      :show="isReviewReminderModal"
      @close="closeReviewReminder"
    />
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '동네 설정 안내',
        type: 'alert',
        msg: `동네 설정이 안되어 있습니다.<br />원활한 서비스를 위해 동네 설정 페이지로 이동합니다.`,
      }"
      @close="popupClose"
    />
    <NoticePopup
      :show="isShowNoticePopup"
      :popupImg="popupImg"
      ref="noticePopup"
      @close="closeNoticePopup"
      @today_close="closeNoticePopupToday"
      @popup_link="popupLink"
    ></NoticePopup>
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import StorageFactory from '@common/lib/common/storage';

import AppPushModal from '@/front/customer/views/home/modal/AppPushModal';

import ReviewReminder from '@/common/components/modal/ReviewReminder';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as productMapActions,
  mapGetters as productMapGetters,
} from '@common/store/modules/product';
import * as productTypes from '@common/store/modules/product/types';

import {
  mapActions as promotionMapActions,
  mapGetters as promotionMapGetters,
} from '@common/store/modules/promotion';
import * as promotionTypes from '@common/store/modules/promotion/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import { mapActions as reviewMapActions } from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import { mapActions as bannerMapActions } from '@common/store/modules/banner';
import * as bannerTypes from '@common/store/modules/banner/types';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import NoticePopup from '@/common/components/modal/NoticePopup';

import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
    AppPushModal,
    ReviewReminder,
    DesignPopup2,
    // EventPopup,
    NoticePopup,
  },
  data() {
    return {
      swiperOptionPromotionBnr: {
        loop: true,
        autoplay: false,
        spaceBetween: 1,
        speed: 500,
      },
      isCompleted: false,
      scrollLocation: 0,
      isVisitName: [
        'Search',
        'MyPage.Main',
        'Mobile.Main',
        'InternetCommerce.Main',
        'Community.Main',
        'Manual.Main',
        'InternetCommerce.PromotionDetailKt',
        'Mobile.DealList',
      ], // 뒤로 이동시 가능한 방문 페이지 정리
      isShowAppPushModal: false,
      isReviewReminderModal: true,

      products: [],

      promotions: [],

      internetPromotion: [],
      internetTvPromotion: [],

      reviewPage: 1,
      reviewSize: 10,
      reviews: [],

      telecomLogoImg: [
        { id: 'SKT', img: 'logo_skt_round' },
        { id: 'KT', img: 'logo_kt_round' },
        { id: 'LGUPLUS', img: 'logo_lgu_round' },
      ],
      knowhowList: [],
      designPopup: false,
      isShowNoticePopup: false,
      popupImg: [
        {
          telecom: 'KT',
          linkId: 0,
          linkName: 'InternetCommerce.PromotionDetailKt',
          params: { type: '100M' },
          img: 'img_promotion_pop_main_kt.png',
        },
        {
          telecom: 'HELLO',
          linkId: 0,
          linkName: 'InternetCommerce.PromotionDetailHello',
          params: {},
          img: 'img_promotion_pop_main_hello.png',
        },
        {
          linkId: 362,
          linkName: 'Notice.Article',
          params: { id: 362 },
          img: 'img_notice_pop_main_01.png',
        }, // 공지 id 확인 필요
      ],
      centerBnr: [
        {
          telecom: 'HELLO',
          linkName: 'InternetCommerce.PromotionDetailHello',
          params: {},
          img: 'img_promotion_bnr_main_hello.png',
        },
        {
          telecom: 'KT',
          linkName: 'InternetCommerce.PromotionDetailKt',
          params: { type: '100M' },
          img: 'img_promotion_bnr_main_kt.png',
        },
      ],
      ktPromotionView: false,
      helloPromotionView: false,
      dealBnr: '',
    };
  },
  async created() {
    // console.log('this.$route.namethis.$route.name');
    // console.log(this.$route.name);
    // console.log('isApp = ' + util.isApp());
    // console.log('isMobile = ' + util.checkMobile());
    // console.log('isPc = ' + !util.checkMobile());

    localStorage.removeItem('redir');
    localStorage.removeItem('dl_id');

    if (util.isApp()) {
      util.nativeEnableBackKey();
    }

    this.getDealBnr();

    await this.fetchMe();

    await this.fetchMainProducts();

    // await this.fetchMainPromotion();

    await this.fetchPromotionView();

    await this.fetchInternetCommercePromotion();

    await this.fetchMainReviews();

    await this.getKnowhowList();

    this.isCompleted = true;

    await this.getReviewPopup(); // 리뷰 작성 가능 팝업

    await this.setPopupBnr(); // 팝업과 배너 셋팅

    await this.setPromotionBnrView('MAIN_CENTER', 'VIEW'); // 노출 확인
  },

  async mounted() {
    if (this.isfirstAttachMainPage()) {
      this.isShowAppPushModal = true;
    }
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  methods: {
    ...bannerMapActions([bannerTypes.CLICK_VIEW_BANNER]),
    ...userMapActions([userTypes.FETCH_ME]),
    ...productMapActions([productTypes.FETCH_MAIN_PRODUCTS]),
    ...promotionMapActions([promotionTypes.FETCH_MAIN_PROMOTIONS]),
    ...reviewMapActions([
      reviewTypes.SELECT_REVIEWS,
      reviewTypes.FETCH_REVIEW_CHECK,
      reviewTypes.FETCH_REVIEW_POPUP,
    ]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_PRODUCTS,
      mobileTypes.UPDATE_MOBILE_VIEW_PRODUCT,
    ]),
    ...internetMapActions([internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION]),
    ...communityMapActions([communityTypes.FETCH_KNOWHOW_LIST]),
    async getKnowhowList() {
      const params = {
        page: 1,
        size: 2,
        myPost: 'N',
        category: '',
        keyword: '',
        orderType: 'CREATED_AT_DESC',
        source: 'MAIN',
      };
      await this[communityTypes.FETCH_KNOWHOW_LIST](params).then(res => {
        this.knowhowList = res.content;
      });
      console.log('this.knowhowList');
      console.log(this.knowhowList);
    },
    async fetchMe() {
      await this[userTypes.FETCH_ME]();

      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        this.designPopup = true;
      }
      console.log('this.userthis.userthis.user');
      console.log(this.user);
    },
    popupClose() {
      this.designPopup = false;

      this.$router.push({
        name: 'Auth.Region',
        query: { from: 'Main' },
      });
    },
    async fetchMainProducts() {
      const mainProducts = await this[productTypes.FETCH_MAIN_PRODUCTS]();
      this.products = mainProducts.content;
      console.log('mainProductsmainProductsmainProductsmainProducts');
      console.log(this.products);
    },
    async fetchInternetCommercePromotion() {
      const params = {
        promotionType: 'MAIN_PERCE',
      };

      const internetCommercePromotion = await this[
        internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION
      ](params);

      // 메인에 노출할 데이터 추출 (배열)
      const mainPromotion = internetCommercePromotion.filter(
        (e, i) => e.display === 'Y',
      );

      console.log(mainPromotion);

      this.internetPromotion = mainPromotion.filter((e, i) => e.tvId === '');

      this.internetTvPromotion = mainPromotion.filter((e, i) => e.tvId !== '');

      console.log('fetchInternetCommercePromotion');
      console.log(internetCommercePromotion);
      console.log(this.internetPromotion);
      console.log(this.internetTvPromotion);
    },
    async fetchMainPromotion() {
      const mainPromotions = await this[promotionTypes.FETCH_MAIN_PROMOTIONS]();

      this.promotions = mainPromotions;

      console.log('promotionspromotionspromotionspromotions');
      console.log(this.promotions);
    },
    async fetchMainReviews() {
      const params = {
        page: this.reviewPage,
        size: this.reviewSize,
      };

      console.log('review params');
      console.log(params);

      const mainReviews = await this[reviewTypes.SELECT_REVIEWS](params);

      this.reviews = mainReviews.content;

      console.log('reviewsreviewsreviews');
      console.log(this.reviews);
    },
    async getReviewPopup() {
      const now = new Date();
      // 접속시간 기준 18시간 이전
      now.setHours(now.getHours() - 18);
      // now.setHours(now.getHours());
      const endDate = format(now, 'yyyy-MM-dd HH:mm:ss');
      const startDate = format(
        new Date(now.setDate(now.getDate() - 28)),
        'yyyy-MM-dd HH:mm:ss',
      );
      const params = {
        startDate: startDate,
        endDate: endDate,
      };

      console.log('review params');
      console.log(params);

      await this[reviewTypes.FETCH_REVIEW_POPUP](params).then(res => {
        console.log('resresresres');
        console.log(res);
        if (res.length > 0) {
          this.$refs.reviewReminder.list = res;
          this.$refs.reviewReminder.startDate = startDate;
          this.$refs.reviewReminder.endDate = endDate;
          this.$refs.reviewReminder.checkReviewList();
          this.isReviewReminderModal = true;
        }
      });
    },
    closeReviewReminder() {
      this.isReviewReminderModal = false;
    },
    // 알림 동의 여부
    isfirstAttachMainPage() {
      let storage = StorageFactory({
        storageType: 'localStorage',
      });

      if (storage.getItem('isfirstAttachMainPage')) {
        return false;
      } else {
        storage.setItem('isfirstAttachMainPage', false);
        return true;
      }
    },
    goLink(link, params = '') {
      this.$router.push({ name: link, params: params });
    },
    goScrollLocation() {
      setTimeout(() => {
        this.$refs.main.scrollTo(0, this.scrollLocation);
      }, 0.5);
      // });
    },

    reco_tab_sel(id, id_con) {
      var listElement = document.querySelector('.reco_tab .on');

      if (listElement != null) {
        listElement.classList.remove('on');
      }
      var someElement = document.getElementById(id);
      someElement.classList.add('on');

      var listElementCon = document.querySelector('.reco_cont.on');

      if (listElementCon != null) {
        listElementCon.classList.remove('on');
      }
      var someElementCon = document.getElementById(id_con);
      someElementCon.classList.add('on');
    },
    p_reco_tab_sel(id, id_con) {
      var listElement = document.querySelector('.p_reco_tab .on');

      if (listElement != null) {
        listElement.classList.remove('on');
      }
      var someElement = document.getElementById(id);
      someElement.classList.add('on');

      var listElementCon = document.querySelector('.p_reco_cont.on');

      if (listElementCon != null) {
        listElementCon.classList.remove('on');
      }
      var someElementCon = document.getElementById(id_con);
      someElementCon.classList.add('on');
    },
    decodeBase64(val) {
      return util.decodeBase64(val);
    },
    getLogoImg(telecomId) {
      const findTelecom = this.telecomLogoImg.findIndex(
        element => element.id == telecomId,
      );
      return this.telecomLogoImg[findTelecom].img;
    },
    goMobileView(item) {
      localStorage.setItem('mobileProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'Mobile.ItemView',
      });
    },
    getProfileNum(userId) {
      return util.setProfile(userId);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    goProductList(telecomId, productType) {
      this.$router.push({
        name: 'InternetCommerce.ProductList',
        query: {
          telecomId,
          productType,
        },
      });
    },
    goProductView(id) {
      this.$router.push({
        name: 'InternetCommerce.ItemView',
        query: {
          promotionId: id,
        },
      });
    },
    goInternetSkylife(path) {
      this.$router.push({ path }).catch(err => {});
    },
    moreReview(storeId) {
      this.isInfoTab = false;
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: storeId },
        query: { type: 'normal' },
      });
    },
    goKnowhowDetail(id) {
      this.$router.push({
        name: 'Knowhow.Detail',
        params: { id: id, isRead: 'Y' },
      });
    },
    getNumberToKorean(number) {
      return util.numberToKorean(number, false);
    },
    async setPopupBnr() {
      let popupImgLeng = this.popupImg.length;
      let centerBnrLeng = this.centerBnr.length;

      if (!this.ktPromotionView) {
        // 팝업 배너 셋팅
        let index = 0;
        for (let i = 0; i < popupImgLeng; i++) {
          console.log(i);
          if (this.popupImg[i].telecom == 'KT') {
            index = i;
            break;
          }
        }
        this.popupImg.splice(index, 1);

        // 메인 중간 배너 셋팅
        index = 0;
        for (let i = 0; i < centerBnrLeng; i++) {
          console.log(i);
          if (this.centerBnr[i].telecom == 'KT') {
            index = i;
            break;
          }
        }
        this.centerBnr.splice(index, 1);
      }

      if (!this.helloPromotionView) {
        // 팝업 배너 셋팅
        let index = 0;
        for (let i = 0; i < popupImgLeng; i++) {
          console.log(i);
          if (this.popupImg[i].telecom == 'HELLO') {
            index = i;
            break;
          }
        }
        this.popupImg.splice(index, 1);

        // 메인 중간 배너 셋팅
        index = 0;
        for (let i = 0; i < centerBnrLeng; i++) {
          console.log(i);
          if (this.centerBnr[i].telecom == 'HELLO') {
            index = i;
            break;
          }
        }
        this.centerBnr.splice(index, 1);
      }

      // 팝업 셋팅
      const today = format(new Date(), 'yyyy-MM-dd');
      // 공지 팝업 레이어 (주석 이것만 풀면 보인다)
      var closeNoticePopupToday = localStorage.getItem('closeNoticePopupToday');

      if (closeNoticePopupToday != today || closeNoticePopupToday == null) {
        await util.sleep(100);
        this.isShowNoticePopup = true;

        this.setPromotionBnrView('MAIN_POPUP', 'VIEW');
      }

      // 중간 배너 셋팅
      if (this.centerBnr.length == 1) {
        // this.$refs.swiperOptionPromotionBnr.$swiper.loop = false;
        this.$refs.swiperOptionPromotionBnr.$swiper.autoplay.stop();
      } else if (this.centerBnr.length > 1) {
        // this.$refs.swiperOptionPromotionBnr.$swiper.loop = true;
        this.$refs.swiperOptionPromotionBnr.$swiper.autoplay.start();
      }
    },
    closeNoticePopup() {
      this.isShowNoticePopup = false;
    },
    closeNoticePopupToday() {
      this.isShowNoticePopup = false;
      const today = format(new Date(), 'yyyy-MM-dd');

      localStorage.setItem('closeNoticePopupToday', today);
    },
    popupLink(id, linkName, params) {
      if (linkName == '') {
        return;
      }
      this.closeNoticePopup();

      if (linkName == 'InternetCommerce.PromotionDetailKt') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'KT2408',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'KT',
          banner_position: 'MAIN_POPUP',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_MAIN_POPUP');

        this.setPromotionBnrView('MAIN_POPUP', 'CLICK', 'KT');
      } else if (linkName == 'InternetCommerce.PromotionDetailHello') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'HELLO',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'HELLO',
          banner_position: 'MAIN_POPUP',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_MAIN_POPUP');

        this.setPromotionBnrView('MAIN_POPUP', 'CLICK', 'HELLO');
      }

      this.$router.push({
        name: linkName,
        params: params,
      });
    },
    clickSlide(index, reallyIndex) {
      this.goInternetPromotion(
        this.centerBnr[reallyIndex].linkName,
        this.centerBnr[reallyIndex].params,
      );
    },
    goInternetPromotion(linkName, params) {
      if (linkName == 'InternetCommerce.PromotionDetailKt') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'KT2408',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'KT',
          banner_position: 'MAIN_CENTER',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_MAIN_CENTER');

        this.setPromotionBnrView('MAIN_CENTER', 'CLICK', 'KT');
      } else if (linkName == 'InternetCommerce.PromotionDetailHello') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'HELLO',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'HELLO',
          banner_position: 'MAIN_CENTER',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_MAIN_CENTER');

        this.setPromotionBnrView('MAIN_CENTER', 'CLICK', 'HELLO');
      }
      this.$router.push({
        name: linkName,
        params: params,
      });
    },
    async fetchPromotionView() {
      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        console.log(1);
      } else {
        let areaArr = this.user.emdAreaName.split(' ');
        let areaSido = areaArr[0];
        let areaSigungu = areaArr[1];
        console.log('fetchPromotionView');
        console.log(areaArr);
        console.log(areaSido);
        console.log(areaSigungu);
        this.ktPromotionView = promotionCfg.getSidoCheck('KT', areaSido);

        let sidoCheck = promotionCfg.getSidoCheck('HELLO', areaSido);
        if (sidoCheck) {
          this.helloPromotionView = promotionCfg.getSigungu(
            'HELLO',
            areaSido,
            areaSigungu,
          );
        } else {
          this.helloPromotionView = false;
        }
      }
    },
    getDealBnr() {
      let num = this.getRandomInt(2);

      this.dealBnr = require(`@/assets/front/images/v2/deal/img_deal_bnr_0${num.toString()}.png`);
    },
    goMobileDeal(place) {
      // 노출 이벤트
      const params = {
        company: 'PERCE',
        campaign: 'DEAL',
        place: place,
        type: 'CLICK',
      };
      this[bannerTypes.CLICK_VIEW_BANNER](params);

      this.$router.push({
        name: 'Mobile.DealList',
        query: { dl: 'perce' },
      });
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    setPromotionBnrView(place, type, telecom = '') {
      if (this.ktPromotionView && (telecom == '' || telecom == 'KT')) {
        // 노출 이벤트
        const params = {
          company: 'KT',
          campaign: 'PROMOTION',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }

      if (this.helloPromotionView && (telecom == '' || telecom == 'HELLO')) {
        // 노출 이벤트
        const params = {
          company: 'HELLO',
          campaign: 'PROMOTION_1',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }
    },
  },
};
</script>
